import { createRoot } from "react-dom/client";

async function initializeApp() {
  let AppComponent;
  console.log(import.meta.env);
  if (import.meta.env.MODE === "replay") {
    AppComponent = (await import("./action-replay/ReplayApp")).default;
  } else {
    AppComponent = (await import("./App")).default;
  }
  createRoot(document.getElementById("root")!).render(<AppComponent />);
}

// createRoot(document.getElementById("root")!).render(
//   // <StrictMode> // strict mode runs useEffect twice which breaks the shopify install as the authorization code gets expired by the time the second useEffect runs
//   <App />
//   // </StrictMode>,
// );

initializeApp();
